/**
 * Reusable pagination control matching CapsInventory style.
 * Options: 12, 24, 48 rows per page (12 default).
 */

import React from 'react';
import { TablePagination, useTheme, alpha } from '@mui/material';

const ROWS_PER_PAGE_OPTIONS = [12, 24, 48];
const DEFAULT_ROWS_PER_PAGE = 12;

export default function PaginationController({
  count,
  page,
  onPageChange,
  rowsPerPage = DEFAULT_ROWS_PER_PAGE,
  onRowsPerPageChange,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
  component = 'div',
  sx = {}
}) {
  const theme = useTheme();

  return (
    <TablePagination
      component={component}
      count={count}
      page={page}
      onPageChange={(e, newPage) => onPageChange?.(e, newPage)}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={(e) => {
        const value = parseInt(e.target.value, 10);
        onRowsPerPageChange?.(value);
        onPageChange?.(null, 0);
      }}
      rowsPerPageOptions={rowsPerPageOptions}
      sx={{
        px: 3,
        py: 2,
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
          fontSize: '0.9rem',
          fontWeight: 500,
          color: theme.palette.text.primary
        },
        '& .MuiTablePagination-select': {
          border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
          borderRadius: 2,
          px: 2,
          py: 1,
          fontWeight: 500,
          fontSize: '0.9rem',
          background: 'white',
          '&:hover': {
            border: `1px solid ${theme.palette.grey[600]}`,
            bgcolor: 'white'
          }
        },
        '& .MuiTablePagination-actions': {
          '& .MuiIconButton-root': {
            border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
            borderRadius: 2,
            margin: '0 2px',
            background: 'white',
            color: theme.palette.primary.main,
            fontWeight: 500,
            '&:hover': {
              border: `1px solid ${theme.palette.grey[600]}`,
              bgcolor: 'white'
            },
            '&.Mui-disabled': {
              background: alpha(theme.palette.grey[300], 0.5),
              color: theme.palette.grey[500],
              border: `1px solid ${theme.palette.grey[300]}`
            }
          }
        },
        ...sx
      }}
    />
  );
}

export { ROWS_PER_PAGE_OPTIONS, DEFAULT_ROWS_PER_PAGE };
